import classNames from 'classnames';

export const buildDayClassName = ({ date, selectedDatetime }) => {
  const isSelectedDay = date.toLocaleDateString() === selectedDatetime?.toLocaleDateString();

  return classNames('m-1', 'rounded-full', 'hover:rounded-full', {
    'bg-blue-400 font-bold hover:bg-blue-500': isSelectedDay,
    'hover:bg-gray-200': !isSelectedDay,
  });
};
